module.exports = __webpack_public_path__ + "static/media/WordsHavePower_p28-29.0d7529ef.jpg";